import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
require('dotenv').config()

const firebaseConfig = firebase.initializeApp({
    apiKey: process.env.REACT_APP_FIREAPI ,
    authDomain: process.env.REACT_APP_FIREAUTHDOMAIN,
    databaseURL: process.env.REACT_APP_FIREDBURL,
    projectId: process.env.REACT_APP_FIREPROJECTID,
    storageBucket: process.env.REACT_APP_FIRE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREMSGSENDERID ,
    appId: process.env.REACT_APP_FIREAPPID,
    measurementId: process.env.REACT_APP_FIREMEASUREMENTID
});
//firebase.initializeApp(config);

export const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });
export const signInWithGoogle = () => auth.signInWithPopup(provider);

export const db=firebase.firestore();


export default firebaseConfig;
